const switched = require('./switched');

module.exports = { switched };
